export enum RolesTypesEnum {
  ROLE_ADMIN = 'admin',
  ROLE_USER = 'user'
}

export enum RolesLabelsEnum {
  admin = 'ROLE_ADMIN',
  user = 'ROLE_USER'
}
